import { render, staticRenderFns } from "./YouNeed.vue?vue&type=template&id=16f51e66&scoped=true"
import script from "./YouNeed.js?vue&type=script&lang=js&external"
export * from "./YouNeed.js?vue&type=script&lang=js&external"
import style0 from "./YouNeed.scss?vue&type=style&index=0&id=16f51e66&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f51e66",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default})
